<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
    class="o-edition-section-chart"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    key="sectionChart"
    class="o-edition-section-chart">
    <MoleculeEditionMapChart :element="element"/>
    <MoleculeEditionSectionChartFooter/>
  </div>
</template>

<script>
export default {
  name: 'OrganismEditionSectionChart',

  components: {
    MoleculeEditionMapChart: () => import('@/components/molecules/MoleculeEditionMapChart'),
    MoleculeEditionSectionChartFooter: () => import('@/components/molecules/MoleculeEditionSectionChartFooter')
  },

  data () {
    return {
      contenidoNodos: [],
      contenidos: [],
      element: {},
      inscripcionNodos: [],

      filter: {
        tipo: 1
      },

      showLoadingState: 0
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    '$route.params.id' () {
      this.$store.commit('unsetMap')
      this.$store.commit('unsetMapNodes')
      this.$store.commit('unsetMapNodesEnrollment')
      this.$store.commit('unsetSelectedMapNode')
      this.readElement()
    },

    updatedData () {
      if (this.$modal.methodToRun === 'readElement') {
        this.readElement()
      } else if (this.$modal.methodToRun === 'readInscripcionNodos') {
        this.readInscripcionNodos()
      }
    }
  },

  created () {
    this.readElement()
    this.$utils.hideAsideNavigationMenu()
  },

  methods: {
    readElement () {
      this.readInscripcionActivaByProyectoAlumno()
    },

    readInscripcionActivaByProyectoAlumno () {
      this.$services.read('inscripcion', 'readInscripcionActivaByProyectoAlumno', {}, [this.$route.params.id])
        .then(response => {
          this.$store.commit('setSelectedMap', response.data.inscripcion)
          this.element = response.data.inscripcion
          this.contenidos = [response.data.contenido]
          this.$store.commit('setMapContents', [response.data.contenido])
          this.showLoadingState++
          this.showLoadingState++
          this.readContenidoNodos()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readInscripcionNodos () {
      this.$services.read('inscripcion', 'readInscripcionNodos', {}, [this.element.id_inscripcion])
        .then(response => {
          if (response.data.length) {
            this.inscripcionNodos = [...response.data]
            this.$store.commit('setMapNodesEnrollment', this.inscripcionNodos)
            // let nodoId = this.$route.params.subid ? this.$route.params.subid : null
            // this.getNodoActivo(this.contenidoNodos, nodoId)
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readContenidoNodos () {
      this.$services.read('contenido', 'readContenidoNodos', {}, [this.contenidos[0].id])
        .then(response => {
          this.contenidoNodos = [...response.data]
          // TODO: filtrar nodos activos para evitar v-show="activo" en MoleculeEditionAssetContentsTreeNode
          this.$store.commit('setMapNodes', this.contenidoNodos)
          this.readInscripcionNodos()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
